module.exports = __webpack_public_path__ + "img/51600.3dbbc1ee.jpg";